import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './ContentBlock.scss';
import offersCategory from '../offers-category';
import EnvVarsFeaturesContext from '../../../scaffold/EnvVarsFeaturesContext';
import notifyAnalytics from '../notify-analytics';
import formatTestId from '../../../utils/test-id/format-testid';

const ContentBlock = ({
  src,
  alt,
  name,
  text,
  url,
  size,
  multi,
  className,
  hierarchy,
}) => {
  const {
    envVars: { contentPath },
  } = useContext(EnvVarsFeaturesContext);

  const imageSrc = contentPath ? `${contentPath}/images/${src}` : src;

  const isOffer = offersCategory(name, 1);

  const path = hierarchy ? `${hierarchy}|${name}` : name;

  const imageHeight = multi ? 100 : 125;

  return (
    <a
      href={url}
      key={name}
      onClick={() => notifyAnalytics(path, 'cb')}
      className={classNames(
        styles.contentBlock,
        {
          [styles.contentBlock__multi]: multi,
        },
        className
      )}
      data-testid={formatTestId(name, 'content-block-')}
    >
      <img
        className={styles.contentBlockImage}
        src={imageSrc}
        alt={alt}
        height={size === 'large' ? 280 : imageHeight}
      />
      {name && (
        <span
          className={classNames(styles.contentBlockTitle, {
            [styles.contentBlockTitle__offer]: isOffer,
          })}
        >
          {name}
        </span>
      )}
      {text && <p className={styles.contentBlockText}>{text}</p>}
    </a>
  );
};

ContentBlock.defaultProps = {
  name: '',
  text: '',
  size: 'small',
  multi: false,
  className: '',
  hierarchy: '',
};

ContentBlock.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.string,
  multi: PropTypes.bool,
  className: PropTypes.string,
  hierarchy: PropTypes.string,
};

export default ContentBlock;
